import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'arc-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatIcon, NgStyle]
})
export class IconComponent {
    readonly icon = input.required<string>();
    readonly size = input<number>(16);
    readonly fontWeight = input<string>('normal');
}
